import { Badge, Flex } from '@chakra-ui/react';

import {
	AsyncJobStatusEnum,
	STATUS_COLOR_SCHEMES,
	STATUS_LABELS,
	STATUS_TEXT_COLORS,
} from '../../types/asyncExport.types';

interface ExportStatusCellProps {
	row: {
		async_job?: {
			status: AsyncJobStatusEnum;
			progress: number;
		};
	};
}

export const ExportStatusCell = ({ row }: ExportStatusCellProps) => {
	const asyncJob = row.async_job;

	if (!asyncJob) {
		return <span>-</span>;
	}

	const status = asyncJob.status;
	const progress = asyncJob.progress || 0;
	const statusLabel = STATUS_LABELS[status];

	const displayText =
		status === AsyncJobStatusEnum.RUNNING
			? `${statusLabel} - ${progress}%`
			: statusLabel;

	return (
		<Flex
			fontSize='sm'
			fontWeight='500'
			mt='.5em'
			justify='start'
		>
			<Badge
				colorScheme={STATUS_COLOR_SCHEMES[status]}
				color={STATUS_TEXT_COLORS[status]}
				fontSize='sm'
				px={3}
				py={1}
				borderRadius='md'
			>
				{displayText}
			</Badge>
		</Flex>
	);
};
